import {
    FETCHING_ALL_CHAT_USERS_REQUEST, FETCHING_ALL_CHAT_USERS_SUCCEEDED, FETCHING_ALL_CHAT_USERS_FAILED,
    FETCHING_CHAT_USER_REQUEST, FETCHING_CHAT_USER_SUCCEEDED, FETCHING_CHAT_USER_FAILED,
    ASSOCIATE_CHAT_USER_REQUEST, ASSOCIATING_CHAT_USER_SUCCEEDED, ASSOCIATING_CHAT_USER_FAILED,
    FETCHING_NUDGES_REQUEST, FETCHING_NUDGES_SUCCEEDED, FETCHING_NUDGES_FAILED,
    FETCHING_LOCATIONS_FOR_CHAT_USERS_REQUEST, FETCHING_LOCATIONS_FOR_CHAT_USERS_SUCCEEDED, FETCHING_LOCATIONS_FOR_CHAT_USERS_FAILED,
    FETCH_CURRENTLY_VIEWING_ASSET, FETCH_CURRENTLY_VIEWING_ASSET_SUCCEEDED, FETCH_CURRENTLY_VIEWING_ASSET_FAILED,
    WS_ASSET_ANALYTICS_UPDATED, INVALIDATE_LIVE_VIEW_DATA,
    BLOCK_CHAT_USER, BLOCK_CHAT_USER_SUCCEEDED, BLOCK_CHAT_USER_FAILED
  } from 'src/legacy/redux/actions/actionTypes';
  import _ from 'lodash';
  
  const initialState = {
    items: '',
    locations: {
      loading: false,
      items: []
    },
    pagination: {
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 0,
      totalRecordsCount: 0
    }
  }
  
  function chatUsersReducer(state = initialState, action) {  
    switch (action.type) {
  
      case FETCHING_ALL_CHAT_USERS_REQUEST:
        return {
          ...state,
          loading: true,
        }
  
  
      case FETCHING_ALL_CHAT_USERS_SUCCEEDED:
        var items = [];
  
        if (action.payload.currentPage != 0) {
          items = [...state.items, ...action.payload.records];
        } else {
          items = action.payload.records
        }
  
        return {
          ...state,
          items: items,
          loading: false,
          pagination: {
            currentPage: action.payload.currentPage,
            totalPages: action.payload.totalPages,
            recordsPerPage: action.payload.recordsPerPage,
            totalRecordsCount: action.payload.totalRecordsCount
          }
        }
  
      case FETCHING_ALL_CHAT_USERS_FAILED:
        return {
          ...state,
          loading: false,
          error: action.payload.error
        }
  
      case FETCHING_CHAT_USER_REQUEST:
        return {
          ...state,
          item: {
            loading: true
          }
        }
  
      case FETCHING_CHAT_USER_SUCCEEDED:
        var chatUser = action.payload;
        var items = state.items || [];
        var icon = chatUser.type == "contact" ? chatUser.contactDTO.icon : null;
        
  
        var item = {
          chatUserId: chatUser.id,
          id: chatUser.type == "visitor" ? chatUser.visitor.id : chatUser.contactDTO.id,
          firstName: chatUser.firstName,
          lastName: chatUser.lastName,
          uuid: chatUser.uuid,
          lastOnline: chatUser.lastOnline,
          isOnline: chatUser.online,
          lastEngaged: chatUser.lastEngaged,
          type: chatUser.type == "visitor" ? "visitor" : "contact",
          icon: icon,
          isAssociated: chatUser.associated,
          userAssociations: chatUser.userAssociations,
          country: chatUser.country,
          blocked: chatUser.blocked
        }
  
        var index = _.findIndex(state.items, (item) => { return item.id == chatUser.id });
  
        if (index > -1) {
          items[index].lastOnline = chatUser.lastOnline;
          items[index].online = chatUser.online;
        }
  
        return {
          ...state,
          items: items,
          item: item
        }
  
      case FETCHING_CHAT_USER_FAILED:
        console.log(action.payload.error);
  
        return {
          ...state,
          item: {
            error: action.payload.error
          }
        }
  
      case ASSOCIATE_CHAT_USER_REQUEST:
  
        return {
          ...state
        }
  
      case ASSOCIATING_CHAT_USER_SUCCEEDED:
        var chatUser = action.payload;
  
        var item = {
          id: chatUser.type == "visitor" ? chatUser.visitor.id : chatUser.contactDTO.id,
          firstName: chatUser.firstName,
          lastName: chatUser.lastName,
          uuid: chatUser.uuid,
          lastOnline: chatUser.lastOnline,
          isOnline: chatUser.online,
          lastEngaged: chatUser.lastEngaged,
          type: chatUser.type == "visitor" ? "visitor" : "contact"
        }
  
        return {
          ...state,
          item: item
        }
  
      case ASSOCIATING_CHAT_USER_FAILED:
        return {
          ...state,
          error: action.payload.error
        }
  
      case FETCHING_NUDGES_REQUEST:
        return {
          ...state,
          nudges: {
            loading: true
          }
        }
  
      case FETCHING_NUDGES_SUCCEEDED:
        return {
          ...state,
          nudges: {
            loading: false,
            items: action.payload
          }
        }
  
      case FETCHING_NUDGES_FAILED:
        return {
          ...state,
          nudges: {
            loading: false,
            error: action.payload.error
          }
        }
  
      case FETCHING_LOCATIONS_FOR_CHAT_USERS_REQUEST:
        return {
          ...state,
          locations: {
            loading: true,
            items: []
          }
        }
  
      case FETCHING_LOCATIONS_FOR_CHAT_USERS_SUCCEEDED:
        return {
          ...state,
          locations: {
            loading: false,
            items: action.payload
          }
        }
  
      case FETCHING_LOCATIONS_FOR_CHAT_USERS_FAILED:
        return {
          ...state,
          locations: {
            loading: false,
            items: [],
            error: action.payload.error
          }
        }
  
      case FETCH_CURRENTLY_VIEWING_ASSET_SUCCEEDED: 
  
        return {
          ...state,
          item: {
            ...state.item,
            liveView: {
              assetId: action.payload.assetId,
              shareId: action.payload.share,
              pageNumber: action.payload.pageNumber
            }
          }
        }
      
      case FETCH_CURRENTLY_VIEWING_ASSET_FAILED:
        console.log(action.payload);
  
      case WS_ASSET_ANALYTICS_UPDATED:
        if (!_.includes(state.item.uuid, action.payload.chatUserUUID)){
          return {
            ...state
          }
        }
  
        return {
          ...state,
          item: {
            ...state.item,
            liveView: {
              updated: true,
              assetId: action.payload.assetId,
              shareId: action.payload.share,
              pageNumber: action.payload.pageNumber
            }
          }
        }
  
      case INVALIDATE_LIVE_VIEW_DATA:
        return {
          ...state,
          item: {
            ...state.item,
            liveView: {}
          }
        }
      
      case BLOCK_CHAT_USER:
        return {
          ...state,
          item: {
            ...state.item,
            blocking: true
          }
        }
  
      case BLOCK_CHAT_USER_SUCCEEDED:
        var blocked = action.payload.blocked;
  
        return {
          ...state,
          item: {
            ...state.item,
            blocked: blocked,
            blocking: false
          }
        }
  
      case BLOCK_CHAT_USER_FAILED:
        var error = action.payload;
  
        return {
          ...state,
          item: {
            ...state.item,
            error: error,
            blocking: false
          }
        }
  
      default:
        return state;
    }
  }
  
  export { chatUsersReducer };